export const MobileCalVW = (px) => `${(px / 767) * 100}vw`;